import { getFetch } from '../fetch';

import { apiConfig } from '../config';
import { Resource } from '../../../typings';

export function getResourceList(resourceIds: number[]): Promise<Resource[]> {
    const { apiGetResourceList } = apiConfig.getStaticUrls();

    return getFetch(apiGetResourceList, { resourceIds });
}
